import { render, staticRenderFns } from "./DeliverableContactPlaceholder.vue?vue&type=template&id=37082716&"
import script from "./DeliverableContactPlaceholder.vue?vue&type=script&lang=js&"
export * from "./DeliverableContactPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37082716')) {
      api.createRecord('37082716', component.options)
    } else {
      api.reload('37082716', component.options)
    }
    module.hot.accept("./DeliverableContactPlaceholder.vue?vue&type=template&id=37082716&", function () {
      api.rerender('37082716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableContactPlaceholder.vue"
export default component.exports